import { render, staticRenderFns } from "./BaseVersionDownload.vue?vue&type=template&id=cd1873ec&"
import script from "./BaseVersionDownload.vue?vue&type=script&lang=js&"
export * from "./BaseVersionDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports